import { render, staticRenderFns } from "./PerformanceImpactModal.vue?vue&type=template&id=f013e638&scoped=true&"
import script from "./PerformanceImpactModal.vue?vue&type=script&lang=ts&"
export * from "./PerformanceImpactModal.vue?vue&type=script&lang=ts&"
import style0 from "./PerformanceImpactModal.vue?vue&type=style&index=0&id=f013e638&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f013e638",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardText,VCardTitle,VDataTable,VDialog,VIcon,VSkeletonLoader,VTextField})
